type YesNoAnswer = 'yes' | 'no' | '';

export interface UserAnswers {
    drivesForBusiness: YesNoAnswer;
    rentsOfficeSpace: YesNoAnswer;
    usesHomeAsOffice: YesNoAnswer;
    rentOrOwn: string;
    officeSqft: string;
    totalHomeSqft: string;
    percentage: string;
}

// Helper functions for cleaner logic
export const hasReimbursableExpenses = (answers: UserAnswers): boolean => {
    const drivesForBusiness = answers.drivesForBusiness === 'yes';
    const hasHomeOffice = answers.rentsOfficeSpace === 'no' && answers.usesHomeAsOffice === 'yes';
    return drivesForBusiness || hasHomeOffice;
};

export const shouldShowHomeOfficeQuestion = (answers: UserAnswers): boolean => {
    return answers.rentsOfficeSpace === 'no';
};

export const shouldShowHomeOfficeDetails = (answers: UserAnswers): boolean => {
    return answers.rentsOfficeSpace === 'no' && answers.usesHomeAsOffice === 'yes';
};

export const hasNoReimbursements = (answers: UserAnswers): boolean => {
    // If they rent office space, ignore home office values since that question is hidden
    if (answers.rentsOfficeSpace === 'yes') {
        return answers.drivesForBusiness === 'no';
    }

    // If they don't rent office space, check both driving and home office
    return answers.drivesForBusiness === 'no' && answers.usesHomeAsOffice === 'no';
};

// Helper to get answers with home office values cleared for validation when office space is "yes"
export const getAnswersForValidation = (answers: UserAnswers): UserAnswers => {
    if (answers.rentsOfficeSpace === 'yes') {
        return {
            ...answers,
            usesHomeAsOffice: '',
            rentOrOwn: '',
            officeSqft: '',
            totalHomeSqft: '',
            percentage: '0',
        };
    }
    return answers;
};
